import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const parseData = (data) => {
  if (data && (data.actual?.length || data.ideal?.length)){
    return {
      bar: [
        {
          name: "Actual",
          type: 'column',
          data: data.actual.map((item)=> Number(item.value)),
        },
        {
          name: "Ideal",
          type: 'column',
          data: data.ideal.map((item)=> Number(item.value)),
        }
      ],
      category: data.actual.map((item)=>item.name),
    };
  }
  return {
    bar: [],
    category: []
  };
};

const VerticalCompareBar = ({ data, isCart= true, heading, size, }) => {
  
  const [formatData, setFormatData] = useState({
    bar: [],
    category: []
  });
  
  useEffect(() => {
    if(data){
      setFormatData(parseData(data));
    }
  }, [data]);
    
  return (
    <div className={`col row mx-0 ${size} ${isCart ? "mt-3 px-2" : "mt-1"} position-relative`}>
    <div className="row px-0 mx-0 justify-content-between col col-12 ">
      <div className={`${isCart ? "dashboard__card" : ""} col col-12 w-100 flex-basis-100`}>
        {heading ? 
          <div className="d-flex align-items-center">
            <h5 className="mb-1 mt-0">{heading}</h5> 
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="cost-formula-tooltip">
                  <div className="text-left p-2" style={{ fontSize: "11px", lineHeight: "1.3" }}>
                    <p className="mb-1"><strong>1. Actual Cost %</strong></p>
                    <p className="mb-2"> Actual Cost % = (Actual Cost / Sales) × 100</p>
                    <p className="mb-1"><strong>2. Ideal Cost %</strong></p>
                    <p className="mb-0">Ideal Cost % = (Ideal Cost / Sales) × 100</p>
                  </div>
                </Tooltip>
              }
            >
              <i className="fa fa-eye ml-2 text-primary cursor-pointer" style={{ fontSize: "14px", cursor: "pointer" }}></i>
            </OverlayTrigger>
          </div>
        : ""}
        {
          formatData?.bar?.length ? (
            <Chart
              width="100%"
              height= "250px"
              type="bar"
              series={formatData.bar}
              options={{
                chart: {
                  type: "bar",
                },
                plotOptions: {
                  bar: {
                    horizontal: false,
                    distributed: false,
                    borderRadius: 1,
                    columnWidth: "30%"
                  },
                },
                colors: ["#008FFB", "#fa7175"],
                dataLabels: {
                  enabled: false,
                },
                tooltip: {
                  enabled: true,
                  x: {
                    show: true
                  },
                  y: {
                    enabled: true,
                    formatter: function(value){
                      return value.toFixed(2) + "%";
                    }
                  }
                },
                xaxis: {
                  categories: formatData.category,
                  labels: {
                  rotate: -70,
                    style:{
                      fontSize:"10px"
                    }
                  },
                },
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return value + "%";
                    },
                    style:{
                      fontSize:"10px"
                    }
                  },
                  tickAmount: 4,
                },
                legend: {
                  fontSize: "10px",
                  position: "top",
                }
              }}
            />
          ) : ""
        }
      </div>
    </div>
  </div>
  )
}

export default VerticalCompareBar
